import { connect } from "react-redux";

import HeaderMui from "../Components/header/HeaderMui";
import { logout } from "../store/actions/actions";
import { setConvertersManagerOpen, SetLocale, setEnableCRUD } from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    firstName: state.authentication.firstName,
    lastName: state.authentication.lastName,
    user: state.authentication.nickname,
    mail: state.authentication.email,
    enableCRUD: state.enableCRUD,
    authnoaccess: state.authnoaccess,
    permissions: state.authentication.permissions,
  };
};

const mapDispatchToProps = {
  logout,
  setConvertersManagerOpen,
  SetLocale,
  setEnableCRUD,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMui);
